import { message } from '@/components/Message';
import PosButton from '@/components/PosButton';
import { showUserFootprintModal } from '@/components/User/helpers';
import { openUserInPos, User, UserEndpoint } from '@/models/user';
import { IS_POS, IS_WECOM } from '@/utils/env';
import { FormOutlined, NodeIndexOutlined, UploadOutlined, WechatWorkOutlined } from '@ant-design/icons';
import * as wecom from '@wecom/jssdk';
import { ModalProps } from 'antd/es/modal';
import { useCallback, useState } from 'react';
import { useRequest } from '../../api/hooks';
import UserEditModal from './UserEditModal';
import { Grid, Space } from 'antd';

type Props = ModalProps & {
  user: User;
  onSuccess: (newInfo: User) => void;
};

export const BasicInfoOperator = ({ user: userProp, onSuccess, ...modalProps }: Props) => {
  const [action, setAction] = useState<'edit'>();
  const { xs } = Grid.useBreakpoint();
  const { send: updateUserInfo, loading: updateUserInfoLoading } = useRequest<User>(
    {
      method: 'post',
      url: `${UserEndpoint}`,
    },
    {
      manual: true,
    }
  );

  const stopAction = useCallback(() => {
    setAction(undefined);
  }, []);

  return (
    <>
      <UserEditModal
        edit={action === 'edit' ? userProp : undefined}
        loading={updateUserInfoLoading}
        onCancel={stopAction}
        onSubmit={(newInfo: User) => {
          const value = Object.assign({}, userProp, newInfo);
          updateUserInfo({
            method: value.id ? 'put' : 'post',
            data: value,
          })
            .then(rsp => {
              message.success('操作成功，用户信息已保存');
              onSuccess(rsp);
              stopAction();
            })
            .catch(e => {
              message.error(`操作失败: ${e.msg}`);
            });
        }}
      />
      <Space wrap size={[8, 0]}>
        <PosButton
          size="small"
          color="primary"
          variant="outlined"
          icon={<FormOutlined />}
          onClick={() => {
            setAction('edit');
          }}>
          {xs ? '档案' : '编辑档案'}
        </PosButton>
        {IS_WECOM && userProp.wecomId ? (
          <PosButton
            size="small"
            color="primary"
            variant="outlined"
            icon={<WechatWorkOutlined />}
            onClick={async () => {
              // TODO: 还需要判断当前企业客户是否是该客户的跟进人
              wecom.openEnterpriseChat({
                externalUserIds: [userProp.wecomId],
                fail: v => {
                  message.error({
                    content: (
                      <>
                        出错了: {v.errMsg}...code: {v.errCode}
                      </>
                    ),
                  });
                },
              });
            }}>
            会话
          </PosButton>
        ) : null}
        {!IS_POS &&
          <>
            <PosButton
              size="small"
              color="primary"
              variant="outlined"
              icon={<NodeIndexOutlined />}
              onClick={() => {
                showUserFootprintModal(userProp);
              }}>
              足迹
            </PosButton>
            {IS_WECOM &&
              <PosButton
                size="small"
                color="primary"
                variant="outlined"
                icon={<UploadOutlined />}
                onClick={async () => {
                  await openUserInPos(userProp.username);
                  message.success("操作成功");
                }}>
                {xs ? 'POS' : '收银机'}
              </PosButton>}
          </>
        }
      </Space>
    </>
  );
};
